import { computed, Directive, EventEmitter, input, Output } from '@angular/core';
import { IContentAttachment, IResidentS3File, TicketingVersion } from '../../models';

@Directive()
export abstract class AttachmentBaseComponent {
  @Output() tap?: EventEmitter<boolean> = new EventEmitter();
  readonly attachment = input<IResidentS3File>();
  readonly className = input<string>('');
  readonly ticketId = input<string>();
  readonly ticketingVersion = input<TicketingVersion>();
  /**
   * Set together with `contentId` for attachments of a content entity (announcements). Those are
   * downloaded from filer-rs by content id instead of being served by url.
   */
  readonly contentAttachment = input<IContentAttachment>();
  readonly contentId = input<string>();
  readonly attachmentName = computed(
    () => this.contentAttachment()?.fileName ?? this.attachment()?.name
  );
  readonly isContentAttachment = computed(() => !!this.contentAttachment() && !!this.contentId());
}
